import { __decorate } from "tslib";
import { Options as Component, Prop, mixins, Ref } from 'vue-property-decorator';
import isBoolean from 'lodash-es/isBoolean';
import FormMixin from '../FormMixin.mjs';
let FormGeneratorField = class FormGeneratorField extends mixins(FormMixin) {
    modelValue;
    name;
    attribute;
    model;
    field;
    nested;
    isAdmin;
    disabled;
    title;
    validations;
    expandableComponent;
    placeholder;
    isExpandable;
    type;
    isLast;
    operators_attribute;
    errors;
    checkPendingChanges;
    rightAlign;
    forceClose;
    showNestedCondition;
    validationObserver;
    get showConditionalNested() {
        if (this.showNestedCondition instanceof Function) {
            const res = this.showNestedCondition(this.model);
            return res;
        }
        return this.showNestedCondition;
    }
    get inputValue() {
        return this.modelValue;
    }
    set inputValue(value) {
        this.$emit('update:modelValue', value);
    }
    textFormat(field) {
        if (this.modelValue) {
            if (field.textFormat) {
                return field.textFormat({
                    value: this.modelValue,
                    model: this.model,
                    field: this.field,
                    nestedValue: this.nested,
                    vm: this,
                });
            }
            return this.modelValue;
        }
        return '';
    }
    validationProviderName(field) {
        return `validationProvider_${field.attribute}`;
    }
    fieldName(field) {
        return (field.name && field.name.toLowerCase()) || field.attribute;
    }
    elementId(field) {
        return field.id ? field.id : field.attribute;
    }
    buildValidations(field) {
        return (field.validations &&
            field.validations.reduce((obj, v) => {
                obj[v.rule] = v.value || true;
                return obj;
            }, {}));
    }
    showNested(field, model) {
        let { item } = this.nestedModel(field, model);
        let show = this.matchingValue(this.model, item) || false;
        if (show) {
            return true;
        }
        return show;
    }
    matchingValue(_, item) {
        return (!!(this.modelValue && item.type === 'switch' && isBoolean(this.modelValue) && this.modelValue) ||
            (Array.isArray(this.modelValue) && this.modelValue.includes(item)) ||
            this.modelValue === item ||
            this.modelValue?.id === item?.id ||
            false);
    }
    getCaption(field, elementId, fieldAttribute) {
        if (field.caption) {
            if (typeof field.caption === 'function') {
                return field.caption(this.modelValue, this, elementId, fieldAttribute);
            }
            if (Array.isArray(field.caption)) {
                return field.caption;
            }
        }
        return '';
    }
    getFieldAttributes(p, c) {
        p = c.nested ? c.nested.reduce(this.getFieldAttributes, p) : p;
        p = c.values ? c.values.reduce(this.getFieldAttributes, p) : p;
        return c.attribute ? p.push(c.attribute) && p : p;
    }
    showOperator(field) {
        const threshold = field ? field.threshold || 1 : 1;
        return threshold < 0 ? true : this.modelValue && this.modelValue.length > threshold;
    }
    getAttributesText(field, model) {
        const currentModel = {
            ...this.model,
            [field.attribute]: this.modelValue,
        };
        return this.getAttributesTextGlobal(field, currentModel, model);
    }
};
__decorate([
    Prop()
], FormGeneratorField.prototype, "modelValue", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "name", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "attribute", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "model", void 0);
__decorate([
    Prop({ default: {} })
], FormGeneratorField.prototype, "field", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "nested", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "isAdmin", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "disabled", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "title", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "validations", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "expandableComponent", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "placeholder", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "isExpandable", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "type", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "isLast", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "operators_attribute", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "errors", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "checkPendingChanges", void 0);
__decorate([
    Prop({ default: false })
], FormGeneratorField.prototype, "rightAlign", void 0);
__decorate([
    Prop({ default: false })
], FormGeneratorField.prototype, "forceClose", void 0);
__decorate([
    Prop()
], FormGeneratorField.prototype, "showNestedCondition", void 0);
FormGeneratorField = __decorate([
    Component({})
], FormGeneratorField);
export default FormGeneratorField;
//# sourceMappingURL=FormGeneratorField.mjs.map